import { render, staticRenderFns } from "./WhyChoose.vue?vue&type=template&id=7dd9a386&scoped=true&"
import script from "./WhyChoose.vue?vue&type=script&lang=js&"
export * from "./WhyChoose.vue?vue&type=script&lang=js&"
import style0 from "./WhyChoose.vue?vue&type=style&index=0&id=7dd9a386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd9a386",
  null
  
)

export default component.exports